import { StudyState } from '@app/types'
import { PeerReviewStatus } from '../types/peerReview.type'
import { StudyDesignStatus } from '../types/studyDesignStatus.type'
import { Attribute } from './attributes.model'
import { FileMeta } from './file-meta.model'
import { ReviewItem } from './reviewItem.model'
import { Search } from './search.model'
import { StudyDesign } from './studyDesign.model'
import { INCLUDED } from '../types/included-screening-criterion.type'
import { ReviewItemType } from '../types/reviewItemType.type'
import { RegistrationMetadata } from './reviewItemMetadata/registrationMetadata'

export class Registration extends ReviewItem {
  metadata: RegistrationMetadata
  constructor({
    complaintDate,
    reviewId,
    search,
    appraisal,
    fullTextScreening,
    id,
    isFavorite,
    maybeParentStudyId,
    oxfordLevelOfEvidence,
    parentStudyId,
    pdfFile,
    peerReviewStatus,
    synthesis,
    titleAndAbstractScreening,
    studyDesign,
    studyDesignStatus,
    metadata,
  }: {
    id: number
    complaintDate?: Date
    reviewId: number
    search: Search
    appraisal?: { [key: string]: string }
    fullTextScreening?: string
    isFavorite?: boolean
    maybeParentStudyId?: number
    oxfordLevelOfEvidence?: string
    parentStudyId?: number
    pdfFile?: FileMeta
    peerReviewStatus?: PeerReviewStatus
    synthesis?: { attributes: Attribute[] }
    titleAndAbstractScreening?: string
    studyDesign?: StudyDesign
    studyDesignStatus?: StudyDesignStatus
    metadata?: RegistrationMetadata
  }) {
    super({
      complaintDate,
      reviewId,
      search,
      appraisal,
      fullTextScreening,
      id,
      isFavorite,
      maybeParentStudyId,
      oxfordLevelOfEvidence,
      parentStudyId,
      pdfFile,
      peerReviewStatus,
      synthesis,
      titleAndAbstractScreening,
      studyDesign,
      studyDesignStatus,
    })
    this.metadata = new RegistrationMetadata(metadata ?? {})
    this.type = ReviewItemType.Registration
  }

  get state(): StudyState {
    if (this.fullTextScreening === INCLUDED) return StudyState.INCLUDED
    if (
      (this.titleAndAbstractScreening &&
        this.titleAndAbstractScreening != INCLUDED) ||
      (this.fullTextScreening && this.fullTextScreening !== INCLUDED)
    )
      return StudyState.EXCLUDED
    return StudyState.UNSCREENED
  }
}
